<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <header class="content__title pl-0">
            <h1>Chemical Classifications</h1>

            <div class="actions">
                <a class="btn btn-success btn--icon" @click.prevent="showCreateDialog"
                   v-b-tooltip.left title="Add new chemical classification"><i class="zmdi zmdi-plus"></i></a>
            </div>
        </header>

        <div class="card">

            <div class="bg-primary align-items-center d-flex">
                <h5 class="card-header text-white">
                    All Chemical Classifications
                </h5>
                <b-pagination align="right" class="my-auto mr-2 ml-auto"
                              :total-rows="pagination.total"
                              v-model="pagination.page"
                              :per-page="pagination.limit"
                />
            </div>

            <b-table hover stacked="md" :items="tableData" sort-by="name" :fields="table.fields"
                     :per-page="pagination.limit" :current-page="pagination.page"
                     :show-empty="true">
                <template slot="badges" slot-scope="data">
                    <span class="badge badge-danger" v-if="data.item.deleted_at">
                    Disabled
                    </span>
                </template>
                <template slot="actions" slot-scope="row">
                    <b-button @click="showEditDialog(row.item)" variant="secondary btn--icon" v-b-tooltip.hover="'Edit Chemical Classification'">
                        <i class="zmdi zmdi-edit"></i>
                    </b-button>
                </template>
            </b-table>
        </div>
        <CreateModal :close="closeCreateDialog" v-model="creating" v-if="creating" />
        <EditModal :close="closeEditDialog" :classification="editingClassification" v-model="editingClassification" v-if="editingClassification" />
    </div>
</template>

<script>
import listClassificationsQuery from '@views/ChemicalClassifications/Browse/queryListChemicalClassifications.graphql';
import CreateModal from './CreateModal';
import EditModal from './EditModal';

export default {
  name: 'BrowseChemicalClassifications',
  apollo: {
    classifications: {
      query: listClassificationsQuery,
      variables: { input: { include_deleted: true } },
      manual: true,
      result({ data, loading }) {
        if (!loading) {
          this.classifications = data.filterChemicalClassifications.data;
          this.pagination.total = data.filterChemicalClassifications.meta.total;
        }
      },
    },
  },
  data() {
    return {
      loading: 0,
      classifications: [],
      creating: false,
      editingClassification: null,
      pagination: {
        page: 1,
        limit: this.$tableDefaultPageSize,
        total: 0,
      },
      table: {
        fields: [
          {
            key: 'name',
            label: 'Chemical Classification',
            sortable: true,
          },
          {
            key: 'badges',
            label: 'Statuses',
          },
          {
            key: 'actions',
            label: '',
            tdClass: 'text-right',
          },
        ],
      },
    };
  },
  computed: {
    tableData() {
      return (this.classifications || []).map(item => ({ ...item }));
    },
  },
  methods: {
    showEditDialog(classification) {
      this.editingClassification = classification;
    },
    closeEditDialog() {
      this.editingClassification = null;
    },
    showCreateDialog() {
      this.creating = true;
    },
    closeCreateDialog() {
      this.creating = false;
    },
  },
  components: {
    EditModal,
    CreateModal,
  },
};
</script>
